import { getRgObjectsOfType as l, RG_TYPE as m } from "@project-rouge/rg-core";
import { getBuildingChildrenAtLevel as f } from "../../../utils/rg-util/index.js";
import { getPerimeter as c } from "../index8.js";
const u = (r, i, n) => {
  const e = l(r, m.Building);
  if (e.length <= 0)
    return 0;
  let t = 0;
  for (const o of e) {
    const g = f(o, i, n);
    t += c(g);
  }
  return t;
};
export {
  u as getLevelPerimeter
};
//# sourceMappingURL=index27.js.map
